import { ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function CartFab() {
  const { totals, setOpen } = useCart();
  if (totals.count === 0) return null;
  return (
    <button
      onClick={() => setOpen(true)}
      data-testid="cart-fab"
      className="fixed z-[60] bottom-24 md:bottom-6 right-4 md:right-6 brutal-border brutal-shadow-lg bg-[#D92525] text-white px-4 py-3 flex items-center gap-3 hover:translate-y-[-2px] transition-transform"
    >
      <div className="relative">
        <ShoppingBag size={22} strokeWidth={2.5} />
        <span className="absolute -top-2 -right-2 bg-[#FFB800] text-black brutal-border w-5 h-5 flex items-center justify-center text-[10px] font-display leading-none">
          {totals.count}
        </span>
      </div>
      <div className="leading-tight text-left hidden sm:block">
        <div className="text-[10px] uppercase tracking-widest text-[#FFB800]">
          Your Order
        </div>
        <div className="font-display text-lg">
          {totals.total > 0 ? `₹${totals.total}` : `${totals.count} item${totals.count > 1 ? "s" : ""}`}
        </div>
      </div>
      <span className="font-display text-base uppercase tracking-wide pl-1">
        View Cart
      </span>
    </button>
  );
}
